import { createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, normalizeStyle as _normalizeStyle, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
const _hoisted_1 = ["disabled", "title"];
const _hoisted_2 = ["title"];
const _hoisted_3 = ["disabled", "title"];
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    return (_openBlock(), _createElementBlock("div", {
        class: "ui-scale-control",
        style: _normalizeStyle({ zoom: 100 / _ctx.scale }),
        "data-test": "ui_scale_control"
    }, [
        _createElementVNode("button", {
            type: "button",
            disabled: _ctx.scale === _ctx.smallest,
            onClick: _cache[0] || (_cache[0] = ($event) => (_ctx.step(-1))),
            title: _ctx.$t('Smaller')
        }, "A−", 8, _hoisted_1),
        _createElementVNode("button", {
            type: "button",
            class: "ui-scale-control__value",
            onClick: _cache[1] || (_cache[1] = ($event) => (_ctx.change(_ctx.DEFAULT_UI_SCALE))),
            title: _ctx.$t('Back to 100%')
        }, _toDisplayString(_ctx.scale) + "%", 9, _hoisted_2),
        _createElementVNode("button", {
            type: "button",
            disabled: _ctx.scale === _ctx.largest,
            onClick: _cache[2] || (_cache[2] = ($event) => (_ctx.step(1))),
            title: _ctx.$t('Bigger')
        }, "A+", 8, _hoisted_3)
    ], 4));
}
